import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { ScrollProgress } from './ScrollProgress';
import { StickyBookingCTA } from './StickyBookingCTA';
import { CookieConsent } from './CookieConsent';
import { SEO } from './SEO';
import { MaintenanceBanner } from './MaintenanceBanner';
import { PRE_LAUNCH_MODE } from '../../config/maintenance';

export const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-sand text-charcoal font-sans selection:bg-timber/30 selection:text-white">
      <SEO />
      {!PRE_LAUNCH_MODE && <ScrollProgress />}
      {!PRE_LAUNCH_MODE && <MaintenanceBanner />}
      {!PRE_LAUNCH_MODE && <Navbar />}
      <main className="grow">
        <Outlet />
      </main>
      {/* Footer a DOM-ban marad SEO-szempontból (cím, kontakt, brand jelek), de pre-launch módban vizuálisan elrejtve */}
      <div className={PRE_LAUNCH_MODE ? 'hidden' : 'contents'}>
        <Footer />
      </div>
      {!PRE_LAUNCH_MODE && <StickyBookingCTA />}
      {!PRE_LAUNCH_MODE && <CookieConsent />}
    </div>
  );
};
